import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import "../src/configs/i18n";
import Home from "./pages/Home";
import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import SigningSuccess from "./pages/SigningSuccess";
import SigningError from "./pages/SigningError";
import Terms from "./pages/Terms";
import Download from "./pages/Download";

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/news-details/:id" element={<NewsDetails />} />
        <Route path="/signing-error" element={<SigningError />} />
        <Route path="/signing-success" element={<SigningSuccess />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/download" element={<Download />} />

      </>
    )
  );

  return <RouterProvider router={router} />;
}

export default App;
